import {
    Chart,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartSeriesItemTooltip,
    ChartSeriesLabels,
    ChartTitle,
    ChartTooltip
} from '@progress/kendo-react-charts';
import { useLocalization } from '@progress/kendo-react-intl';
import axios from 'axios';

import 'hammerjs';
import { useEffect, useState } from 'react';
import { AccessToken } from '../../config/AccessToken';

export const PriorityValuesChart = () => {

    const SERVER_URL = process.env.REACT_APP_SERVER_URL;

    const [error, setError] = useState('');

    const [priorityNotStartedFirstRange, setPriorityNotStartedFirstRange] = useState(0);
    const [priorityAssignedFirstRange, setPriorityAssignedFirstRange] = useState(0);
    const [priorityDoingFirstRange, setPriorityDoingFirstRange] = useState(0);
    const [priorityNotStartedSecondRange, setPriorityNotStartedSecondRange] = useState(0);
    const [priorityAssignedSecondRange, setPriorityAssignedSecondRange] = useState(0);
    const [priorityDoingSecondRange, setPriorityDoingSecondRange] = useState(0);
    const [priorityNotStartedThirdRange, setPriorityNotStartedThirdRange] = useState(0);
    const [priorityAssignedThirdRange, setPriorityAssignedThirdRange] = useState(0);
    const [priorityDoingThirdRange, setPriorityDoingThirdRange] = useState(0);
    const [priorityNotStartedFourthRange, setPriorityNotStartedFourthRange] = useState(0);
    const [priorityAssignedFourthRange, setPriorityAssignedFourthRange] = useState(0);
    const [priorityDoingFourthRange, setPriorityDoingFourthRange] = useState(0);
    const [priorityNotStartedFifthRange, setPriorityNotStartedFifthRange] = useState(0);
    const [priorityAssignedFifthRange, setPriorityAssignedFifthRange] = useState(0);
    const [priorityDoingFifthRange, setPriorityDoingFifthRange] = useState(0);

    const [instance, accessTokenRequest] = AccessToken();


    useEffect(() => {
        getPriorityValues();
    }, []);

    const getPriorityValues = async () => {
        let languageId = localStorage.getItem('languageId');

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId  };
            try {
                const res = await axios.get(`${SERVER_URL}/synchro/GetMissionsPerStatesAndPriority`, { headers })
                const data = res.data.data

                data.forEach((priority:any) => {
                    switch (priority.rangePriority) {
                        case '1 - 20':
                            setPriorityNotStartedFirstRange(priority.notStarted)
                            setPriorityAssignedFirstRange(priority.assigned)
                            setPriorityDoingFirstRange(priority.doing)
                            break;
                        case '21 - 40':
                            setPriorityNotStartedSecondRange(priority.notStarted)
                            setPriorityAssignedSecondRange(priority.assigned)
                            setPriorityDoingSecondRange(priority.doing)
                            break;
                        case '41 - 60':
                            setPriorityNotStartedThirdRange(priority.notStarted)
                            setPriorityAssignedThirdRange(priority.assigned)
                            setPriorityDoingThirdRange(priority.doing)
                            break;
                        case '61 - 80':
                            setPriorityNotStartedFourthRange(priority.notStarted)
                            setPriorityAssignedFourthRange(priority.assigned)
                            setPriorityDoingFourthRange(priority.doing)
                            break;
                        case '81 - 100':
                            setPriorityNotStartedFifthRange(priority.notStarted)
                            setPriorityAssignedFifthRange(priority.assigned)
                            setPriorityDoingFifthRange(priority.doing)
                            break;
                    }   
                });               
                
                //setMissionsTotal(data.notStarted + data.assigned + data.doing)
                
            }catch (error: any) {
                setError(error);
            }
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }
    
    const labelContent = (e: any) => (e.category);
    const categories = ["1 - 20", "21 - 40", "41 - 60", "61 - 80", "81 - 100"];
    
    const localizationService = useLocalization();
    
    const series: any = [
        {
            name: localizationService.toLanguageString('synchro.not_assigned', 'NOT_FOUND'), 
            data: [priorityNotStartedFirstRange, priorityNotStartedSecondRange, priorityNotStartedThirdRange, priorityNotStartedFourthRange, priorityNotStartedFifthRange], 
            "color": "#018CA5"
        },
        {
            name: localizationService.toLanguageString('synchro.assigned', 'NOT_FOUND'), 
            data: [priorityAssignedFirstRange, priorityAssignedSecondRange, priorityAssignedThirdRange, priorityAssignedFourthRange, priorityAssignedFifthRange], 
            "color": "#54A2B4"
        },
        {
            name: localizationService.toLanguageString('synchro.doing', 'NOT_FOUND'), 
            data: [priorityDoingFirstRange, priorityDoingSecondRange, priorityDoingThirdRange, priorityDoingFourthRange, priorityDoingFifthRange], 
            "color": "#74C3EE"
        },
    ];

    return(
        <>
            <Chart>
                <ChartTooltip format="{0}" />
                <ChartCategoryAxis>
                    <ChartCategoryAxisItem categories={categories} startAngle={45} />
                </ChartCategoryAxis>
                <ChartSeries>
                    {series.map((item:any, idx:any) => (
                        <ChartSeriesItem key={idx} type="column" data={item.data} name={item.name} color={item.color}>
                            <ChartSeriesItemTooltip background="#34A3B7" format="{0}" />
                        </ChartSeriesItem>
                    ))}
                </ChartSeries>
                <ChartLegend 
                    position="top" 
                    orientation="horizontal" 
                    labels={{ color: "#018CA5" }} 
                />                
            </Chart>
            <p style={{ fontSize:'13px', color:'#838393'}}>{localizationService.toLanguageString('synchro.range_of_priority_values', 'NOT_FOUND')}</p>
        </>
    )
}